/**
 * listPic  主列表图片地址
 * contentPic  内容页图片地址
 * title  标题
 * synopsis  简介
 * contentList  文章内容
 */
const articleList = [
  {
    listPic: 'https://spjy-oss.oss-cn-shanghai.aliyuncs.com/ketang_h5/1.png', // 主列表图片地址
    contentPic: 'https://spjy-oss.oss-cn-shanghai.aliyuncs.com/ketang_h5/1.png', // 内容页图片地址
    title: '贷款类诈骗', // 标题
    time: '3分钟前',
    author: '小助理',
    synopsis: '2020年7月，宜宾某高校学生何某某在手机上下载了一个名叫“来分期”的APP进行贷款，下载完成后接到APP“客服”来电', // 简介
    contentList: [
      {
        title: '',
        content: '客服”要求何某某添加她的QQ号，在QQ上教何某某如何进行贷款操作。'
      }, {
        title: '',
        content: '何某某在“客服”的指导下在平台贷款15000元后，发现自己APP账户被冻结。'
      }, {
        title: '',
        content: '“客服”称是何某某操作失误导致，需要缴纳3500元，何某某缴纳解冻费后，对方又以账户流水不够、操作次数太多、信誉度不够等多种理由让何某某4次转账总计63000元。'
      }, {
        title: '',
        content: '之后对方又以其操作有误为由，让其还需缴纳24000元，何某某这才意识到自己可能被骗，随即到公安机关报案。'
      }, {
        title: '防范：办理贷款一定要到正规的金融机构，正规贷款在放款之前不会收任何费用!',
        content: '任何网络贷款，凡是在放款之前，以交纳“手续费、保证金、解冻费”等名义要求转账刷流水、验证还款能力的，统统都是诈骗！'
      }
    ] // 文章内容
  },
  {
    listPic: 'https://spjy-oss.oss-cn-shanghai.aliyuncs.com/ketang_h5/2.png',
    contentPic: 'https://spjy-oss.oss-cn-shanghai.aliyuncs.com/ketang_h5/2.png',
    title: '冒充电商客服类诈骗', // 标题
    time: '10分钟前',
    author: '小助理',
    synopsis: '2020年4月，泸州某高校教师刘某某接到某购物网站“客服”来电，称其购买商品质量存在问题可以退款但需要走流程，随后与刘某某电话沟通中，工作人员要求刘某某提供支付宝账号，加为好友后，对方又以“走赔付流程”为由给刘某某提供了一个二维码，最终，通过几次扫码、验证操作，刘某某支付宝内的60299元被转走。', // 简介
    contentList: [{
        title: '',
        content: '防范：在这类骗局里，不法分子假冒网店客服，以货物质量存在问题为由，提出理赔，这时受害人为了减少损失就会主动提供自己的手机号、银行卡号等信息，并轻易扫描对方提供的二维码等，最终落入不法分子的圈套。警方提醒，接到所谓客服的“退款”短信或者电话时，不要轻信，也不要随意添加陌生客服的QQ、微信，应该第一时间向官方客服、商家核实。'
      }
    ] // 文章内容
  },
  {
    listPic: 'https://spjy-oss.oss-cn-shanghai.aliyuncs.com/ketang_h5/3.png',
    contentPic: 'https://spjy-oss.oss-cn-shanghai.aliyuncs.com/ketang_h5/3.png',
    title: '冒充公检法类诈骗', // 标题
    time: '15分钟前',
    author: '小助理',
    synopsis: '2020年1月，德阳某高校学生唐某某接到一个电话，对方自称是澳洲的一个包裹公司，公司告诉唐某某从澳洲寄往广州的包裹里面有违禁物，随后将电话转到“广州市公安局”，“广州市公安局”的“警察”告知唐某某，除了邮寄违禁物以外还涉嫌诈骗，称唐某某一张银行卡里有160万赃款，恐吓唐某某说要来抓她。唐某某担心被抓，于是向指定账户缴纳保证金共计20万人民币', // 简介
    contentList: [
      {
        title: '',
        content: '防范：在这类骗局里，诈骗分子在非法获取受害人信息后，会冒充公安机关与受害人取得联系，利用公检法的威信力击破受害人的心理防线。然后，骗子以受害人涉嫌犯罪恐吓受害人，为了增加真实性，骗子一般还会发送伪造的拘留证、逮捕证等法律文书，进一步击溃受害人的心理防线。最后，骗子以让受害人洗脱罪名，自证清白为由，诱导受害人将名下的钱款转入所谓的“安全账户”，对资产进行审查。警方提醒，公检法机关不会通过电话办案，也不会相互转接电话，更不存在所谓的“安全账户”。'
      }
    ] // 文章内容
  },
  {
    listPic: 'https://spjy-oss.oss-cn-shanghai.aliyuncs.com/ketang_h5/4.png',
    contentPic: 'https://spjy-oss.oss-cn-shanghai.aliyuncs.com/ketang_h5/4.png',
    title: '冒充领导类诈骗', // 标题
    time: '3小时前',
    author: '小助理',
    synopsis: '2020年5月，乐山某高校学生杨某某接到一陌生电话自称是“李主任”，“李主任”知道杨某某的学校和家庭信息，说了一些关心杨某某学习的话后，又称有熟人找他借钱，为了日后方便将钱收回，想以杨某某的名义借给别人。随后“李主任”让杨某某发一张自己的银行账号过去，很快“李主任”就给杨某某发了一张转账10万的银行电子回单图片，并发了一个银行账户让其转账。杨某某随即分三笔转给对方共计10万元。第二天，杨某某发现“李主任”的10万转账仍没有到账，就立即通过电话联系了真正的李主任，这才意识到自己被骗了。', // 简介
    contentList: [
      {
        title: '',
        content: '防范：在这类骗局里，诈骗分子事先通过各种渠道获得受害人的姓名、工作、职务等个人资料，然后通过电话、微信等方式冒充领导与被害人联系。骗子往往能准确说出受害人姓名等信息，并以关心工作、生活等话题开始拉近距离。待受害人卸下防备之心后，骗子通常会编造正在开会、参加活动、办事急需用钱等理由，要求受害人尽快帮忙转账至指定账户。而受害人由于敬畏上级不敢跟领导核实信息，或者出于领导的求助不好意思回绝，或者看到骗子发过来的虚假汇款电子回单而相信，极有可能上当受骗。警方提醒，在接到领导发来的转账消息或者要求转账的电话时，一定要仔细核实对方身份，也可以通过自己保存的领导的联系方式主动联系领导核实，不要轻信来电或接收的消息，更不要轻易转账。</br>女生：不在啊，我在XXX</br>这样的开场完全不会让对方感到生疏，通过这种幽默悬疑式开场勾起女生的兴趣，带动女生的情绪。'
      }
    ] // 文章内容
  },
  {
    listPic: 'https://spjy-oss.oss-cn-shanghai.aliyuncs.com/ketang_h5/5.png',
    contentPic: 'https://spjy-oss.oss-cn-shanghai.aliyuncs.com/ketang_h5/5.png',
    title: '杀猪盘诈骗', // 标题
    time: '3小时前',
    author: '小助理',
    synopsis: '2020年5月，雅安某高校教师金某某在“世纪佳缘”交友网站上面认识一网友，对方介绍自己在成都私人IT企业上班，添加微信后，金某某与IT男相谈甚欢。确立恋爱关系后，IT男让金某某帮助他在某赌博网站充值买涨，因为每次帮助对方买涨都是赚钱。金某某感觉有利可图，自己便根据对方教的方法投钱。金某某从5月下旬至6月上旬，先后通过自己的工商银行、农业银行、建设银行等多个银行账户转入人民币一百八十余万元。6月13日，金某某发现网站登录异常，才发现自己被骗。 但是往往事情不随人意，有的女生谈恋爱的另一半却不是这么的理想，越谈越让自己失望，最后当失望攒到一定的程度之后，就会安静的离开。其实安静离开的女人最精明，为什么这么说呢？我们来分析其原因。', // 简介
    contentList: [
      {
        title: '',
        content: '防范：在这类骗局里，骗子会在婚恋网站交友平台里将自己包装成单身高富帅、白富美或成功人士。然后有计划的与受害人培养感情，通过展现才华、炫富、嘘寒问暖等方式让受害人对其产生好感，并快速确立恋爱关系。随后，骗子让受害人帮助他操作投资理财账户或者赌博网站，让受害人感觉其很会赚钱，引诱参与，并且一开始会让受害人尝到甜头。待受害人深信不疑投入大量资金准备拼死一搏后， “完美恋人”就消失不见了。'
      }
    ] // 文章内容
  },
  {
    listPic: 'https://spjy-oss.oss-cn-shanghai.aliyuncs.com/ketang_h5/6.png',
    contentPic: 'https://spjy-oss.oss-cn-shanghai.aliyuncs.com/ketang_h5/6.png',
    title: '红包返利类诈骗', // 标题
    time: '3小时前',
    author: '小助理',
    synopsis: '2020年6月，巴中某高校学生张某在一个抖音“网红”的QQ空间里看到一条内容为“朋友过生回馈粉丝充值返利”的活动，里面有一个QQ群二维码，张某扫码进入QQ群内，群主发布信息称想参加活动，需加一个微信，张某添加对方微信后分别充值了100元、200元，对方以必须一次性充值300元或500元，不能分开充值为由拒绝按活动返利。于是张某要求退钱，最终张某按照对方要求操作进行退款，共计被骗6300元。', // 简介
    contentList: [
      {
        title: '',
        content: '防范：在这类骗局里，骗子冒充各种身份，通过QQ、微信等方式添加受害人，并在微信群、朋友圈、QQ群、QQ空间等渠道发布信息，以“土豪过生日返利”、“明星后援会发福利”等五花八门虚假借口，引诱受害者上钩。受害者贪图轻松赚大钱，直到被对方删除或拉黑才发现被骗。警方提醒，天上不会掉馅饼，不要轻信红包返利活动，不要轻易点击各种来路不明的红包链接'
      }
    ] // 文章内容
  },
  {
    listPic: 'https://spjy-oss.oss-cn-shanghai.aliyuncs.com/ketang_h5/7.png',
    contentPic: 'https://spjy-oss.oss-cn-shanghai.aliyuncs.com/ketang_h5/7.png',
    title: '刷单返利类诈骗', // 标题
    time: '3小时前',
    author: '小助理',
    synopsis: '2020年8月，泸州某高校学生梁某某跟着一个兼职群里认识的人在网上刷单，对方先让梁某某练习刷单，购买低价商品，购买成功后迅速将本金和佣金返还。之后就提高刷单金额，同时声称一次任务包含多个订单，需要所有订单都完成才能返款。梁某某转账4472元后被对方拉黑。', // 简介
    contentList: [
      {
        title: '',
        content: '防范：任何要求垫资的兼职和刷单都是诈骗，不要有“贪图小便宜”和“轻轻松松赚大钱”的心理。如果刷单真的那么赚钱，为什么大家还要辛辛苦苦上班呢？所以不要轻信所谓的高额回报，天上不会掉馅饼！记住，网络刷单本身就属于违法行为！'
      }
    ] // 文章内容
  },
  {
    listPic: 'https://spjy-oss.oss-cn-shanghai.aliyuncs.com/ketang_h5/8.png',
    contentPic: 'https://spjy-oss.oss-cn-shanghai.aliyuncs.com/ketang_h5/8.png',
    title: '网络游戏产品虚假交易类诈骗', // 标题
    time: '3小时前',
    author: '小助理',
    synopsis: '2020年7月，自贡小学生邓某某在家中用母亲的QQ玩耍时，被一个名叫“和平精英福利群9”的QQ群拉入，看到群里说可以免费领取小黄鸭、玛莎拉蒂—火箭—SS8手册等皮肤。群管理员问邓某某要不要游戏皮肤，邓某某回复后，对方提出需要两个手机进行领取，邓某某使用父亲手机扫描对方提供的二维码后被转走15088元。', // 简介
    contentList: [
      {
        title: '',
        content: '防范：家长们应加强对孩子进行网络安全及金钱意识教育，让孩子明白不要轻易与陌生人进行钱款交易，避免孩子落入不法分子的圈套。若孩子确实有账户充值、装备购买等需求，在家人同意并认为合理的情况下，通过正规渠道由家人代为操作，切勿让孩子自行操作。切勿相信任何物品或道具免费赠送。'
      }
    ] // 文章内容
  },
  {
    listPic: 'https://spjy-oss.oss-cn-shanghai.aliyuncs.com/ketang_h5/9.png',
    contentPic: 'https://spjy-oss.oss-cn-shanghai.aliyuncs.com/ketang_h5/9.png',
    title: '虚假征信类诈骗', // 标题
    time: '一天以前',
    author: '小助理',
    synopsis: '2020年6月，巴中某学校教师郭某某接到陌生电话，对方自称是京东客服，声称郭某某在2015年读书期间，在网上有贷款记录，影响其征信。对方以帮助消除贷款记录，恢复征信为由，让郭某某在支付宝借呗上贷款66000元，加上自己的卡内现金7500元，共计现金73500元转到指定账户，郭某某共计被骗73500元。 但是异性之间的夸赞也是一样的含义吗？当一个男人夸你有气质啥意思？我们一起来分析分析。', // 简介
    contentList: [
      {
        title: '',
        content: '防范：在这类骗局里，骗子冒充金融公司、银行客服，称受害人有过“网贷”经历，他们可以“帮助注销网贷平台账号，提升征信”。然后骗子会诱导受害人添加“客服”QQ，“客服”向受害人提供伪造的营业执照、工作证件，骗取信任。随后，骗子诱导受害人下载网贷平台，告诉受害人从网贷平台上贷款出来再还回去，就能注销了。最后，骗子谎称受害人注册网贷平台过多，其银行卡自动还款会失败，要求把钱转到“客服”指定的账户内，便可帮助还款，受害人一旦转钱，“客服”随即消失。警方提醒，任何个人或机构都不能删除和修改征信，凡是自称贷款平台客服，能够提供注销、“洗白”不良网贷征信记录服务的电话都是诈骗！'
      }
    ] // 文章内容
  }
]

export default articleList
